import { type messages } from '@databases/snackbar/messages';
import { currentSnackbarState } from '@databases/snackbar/snackbar';

export class UnfoundEntryError extends Error {
  entryId: string;
  constructor(message: string, entryId: string) {
    super(message);
    this.entryId = entryId;
  }
}

export class UnfoundFieldError extends Error {
  fieldId: string;
  constructor(message: string, fieldId: string) {
    super(message);
    this.fieldId = fieldId;
  }
}

/*
 * @deprecated Opt to throw error in the component responsible for the action directly
 */
export class TranslatableError extends Error {
  i18nId: string;
  i18nVariables: Record<string, string | number>;

  constructor(
    message: string,
    i18nId: keyof typeof messages,
    i18nVariables?: Record<string, string | number>
  ) {
    super(message);
    this.i18nId = i18nId;
    this.i18nVariables = i18nVariables || {};
  }
}

export const showErrorSnackbar = (flagId: string, body: string) => {
  currentSnackbarState.setMessage(body, {
    id: flagId,
    type: 'error',
    hideAfter: 3000
  });
};
